var vskoAvatar = angular.module('vskoAvatar', []);

vskoAvatar.directive('vskoAvatar', [function () {
  'use strict'
  return {
    restrict: 'A',
    scope: {
      avatarName: '@vskoAvatar',
      avatarSize: '@?vskoAvatarSize',
      avatarColor: '@?vskoAvatarColor'
    },
    link: function ($scope, element) {

      var initials = $scope.avatarName.toUpperCase();

      if (initials.length > 2) {
        initials = initials.match(/\b\w/g) || [];
        initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
      }

      var size = $scope.avatarSize;
      $scope.getStyleClass = function () {
        var styles = [];

        styles.push('c-avatar');

        if (size === 'small') {
          styles.unshift('c-avatar-s');
        }

        return styles.join(' ');
      };

      var color = $scope.avatarColor || '#1866B2';

      var div = angular.element('<div class=\'' + $scope.getStyleClass() + '\' style=\'background-color:' + color + '\'>' + initials + '</div>');

      element.prepend(div);
    }
  };
}]);
